export const SITE_TEXTS_BOOT_SCOPES = [
	"login",
	"my-account",
	"components",
	"branding",
	"folder",
	"forms",
	"documentTypes",
	"office",
	/** Libellés rôles tiers (`thirdParty.roleLabel.*`) ; en seed le `scope` doit être exactement cette chaîne (voir docs/Deployment.md §3.1). */
	"thirdParty",
] as const;
export const SITE_TEXTS_BOOT_LOCALE = "fr-FR" as const;
